import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(
	({ spacing, margins = { bottom: 0, top: 0 }, transitions, showBorders }) => ({
		root: {
			position: 'absolute',
			top: spacing(showBorders ? margins.top / 2 : 0),
			left: spacing(showBorders ? margins.left / 2 : 0),
			right: spacing(showBorders ? margins.right / 2 : 0),
			bottom: spacing(showBorders ? margins.bottom / 2 : 0),
			transition: transitions.create(['top', 'left', 'right', 'bottom']),
			zIndex: -1,
			'&:after': {
				content: '""',
				transition: transitions.create('opacity'),
				backgroundColor: 'black',
				width: '100%',
				height: '100%',
				position: 'absolute',
				top: 0,
				left: 0,
				opacity: ({ shading }) => (shading || 0) / 100,
			},
		},
	}),
	{ name: 'PDFBackgroundImage' },
)

export default useStyles
